import { MODULOS_DESCRICAO } from 'src/utils/modulos';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const CONFIGURATION_PAGE_ALL_SECTIONS_ID = 'todos';

export const TIPO_MATRIZ_RISCO = {
  RISCO: 1,
  ITENS_IMPACTADOS: 2,
};

export const STATUS_BADGE = {
  Ativo: 'ativo',
  Inativo: 'inativo',
  Obrigatorio: 'obrigatorio',
  Exportacao: 'exportacao',
};

export const CORES_STATUS_BADGE = {
  cinza: {
    id: 'cinza',
    labelId: 'cinza',
    labelDefault: 'Cinza',
    cor: '#404040',
    corFundo: '#F5F5F5',
  },
  azul: {
    id: 'azul',
    labelId: 'azul',
    labelDefault: 'Azul',
    cor: '#0C4A6E',
    corFundo: '#E0F2FE',
  },
  roxo: {
    id: 'roxo',
    labelId: 'roxo',
    labelDefault: 'Roxo',
    cor: '#4C1D95',
    corFundo: '#EDE9FE',
  },
  verde: {
    id: 'verde',
    labelId: 'verde',
    labelDefault: 'Verde',
    cor: '#3F6212',
    corFundo: '#ECFCCB',
  },
  laranja: {
    id: 'laranja',
    labelId: 'laranja',
    labelDefault: 'Laranja',
    cor: '#9A3412',
    corFundo: '#FFEDD5',
  },
  vermelho: {
    id: 'vermelho',
    labelId: 'vermelho',
    labelDefault: 'Vermelho',
    cor: '#991B1B',
    corFundo: '#FEE2E2',
  },
};

export const OPCOES_COR_STATUS_BADGE = [
  CORES_STATUS_BADGE.cinza,
  CORES_STATUS_BADGE.azul,
  CORES_STATUS_BADGE.roxo,
  CORES_STATUS_BADGE.verde,
  CORES_STATUS_BADGE.laranja,
  CORES_STATUS_BADGE.vermelho,
];

export const ENTIDADES_CUSTOMIZADAS = {
  PONTO_CONTROLE: 101,
  PONTO_CONTROLE_REVISAO: 105,
  EVENTOS_RISCO: 106,
  PLANOS_CONTIGENCIA: 107,
  HISTORICO_CARGO_COLABORADOR: 108,
  PROJETO_STATUS_REPORT: 200,
  AUDITORIA_RISCO: 201,
  CONTROL_SELF_ASSESSMENT: 202,
  CONTROL_SELF_ASSESSMENT_TEMPLATE: 203,
  CONTROL_SELF_ASSESSMENT_EXECUCAO: 204,
  PLANO_AUDITORIA: 205,
  GESTAO_DOCUMENTOS: 206,
  PONTO_AUDITORIA: 207,
  PERDA_OPERACIONAL: 208,
  LICOES_APRENDIDAS: 213,
  TESTE_CONTROLE: 214,
  OCORRENCIA: 215,
};

/* Mesmo ID do backend (Stratec.Domain.FlyWeight.TipoOrigemDetalhamentoInvestimentoCusteio) */
export const TIPO_ORIGEM_DETALHAMENTO_INVESTIMENTO_CUSTEIO = {
  ACOES: 1,
  SUBPROJETOS: 2,
  PLANO_CONTAS: 3,
};

/* Stratec.Domain.FlyWeight.TipoOrigem */
export const TIPO_ORIGEM = {
  PESQUISA_CLIMA: 28,
};

/* Mesmo ID do backend (Stratec.Domain.FlyWeight.CategoriaImportacao) */
export const CATEGORIA_IMPORTACAO = {
  OUTROS: 22,
};

/* Mesmo ID do backend (Domain.FlyWeight/Filtro.cs) */
export const FILTROS = {
  /*SEED */
  RELATORIOBSC: 66,
  ACAO_TAREFA: 68,
  LOG_AUDITORIA: 76,
  FILTROFAVORITO: 77,
  PLANOCONTAS: 79,
  COLABORADOR_LOOKUP: 95,
  CONFIGURACAO_GRAFICO_INDICADOR: 96,
  CONFIGURACAO_GRAFICO_PARAMETRO: 98,
  CONFIGURACAO_GRAFICO_OBJETIVO: 99,
  CONFIGURACAO_GRAFICO_INDICADOR_RISCO: 100,
  /*GESTAO RISCO */
  PONTO_CONTROLE: 313,
  REVISOES_PENDENTES: 314,
  VALIDACOES_REVISOES_PONTO_CONTROLE: 315,
  REVISOES_PONTO_CONTROLE: 316,
  AVALIACOES_PENDENTES: 317,
  RISCO_GRAFICOSCORE: 323,
  REVISOES_RISCO_PONTO_CONTROLE: 326,
  PLANOS_CONTIGENCIA: 334,
  EVENTO_RISCO: 335,
  MODELO_CHECKLIST: 340,
  AUDITORIA_RISCO: 343,
  GESTAO_MUDANCAS_RISCO: 345,
  CONTROL_SELF_ASSESSMENT: 346,
  PLANO_AUDITORIA: 347,
  PONTO_AUDITORIA: 348,
  TESTE_CONTROLE: 349,
  GESTAO_MUDANCAS_RISCO_AVALIACAO: 351,
  PERDAS_OPERACIONAIS: 352,
  RISCO_CATEGORIZADO: 353,
  /* AVALIACAO DE DESEMPENHO */
  COLABORADOR_HISTORICO_OCUPACAO: 401,
  COLABORADOR_HISTORICO_OCUPACAO_CARGO: 402,
  MODELO_AVALIACAO: 403,
  GRUPO_AVALIADOS: 404,
  ELEMENTO_MODELO_AVALIACAO: 405,
  MODELO_ESCALA: 406,
  CICLO_AVALIACAO: 407,
  CICLO_AVALIACAO_PROCESSO_AVALIATIVO: 408,
  PDI: 409,
  REUNIAO_GENTE: 423,
  ONEAONE: 411,
  BLOCO_NOTAS: 412,
  LIFTBOX: 413,
  MAPA_SUCESSAO_PESSOAS: 414,
  MAPA_SUCESSAO_POSICOES: 415,
  META_INDIVIDUAL: 416,
  FEEDBACK_CONTINUO: 417,
  CICLO_META_INDIVIDUAL: 418,
  MAPA_SUCESSAO_LIST: 419,
  CARGOS: 420,
  PESQUISA_CLIMA: 421,
  GRUPO_DOSSIE: 422,
  CALIBRACAO: 410,
  REUNIAO_GENTE_LOOKUP: 424,
  //Objetivos
  OKR: 501,
  CHAVERESULTADO_INICIATIVA: 502,
  CHECKINKEY: 503,
  // ESCRITÓRIO DE PROJETOS
  PROJETO_STATUS_REPORT: 600,
  ACAO_APROVACAO: 604,
  APROVAR_ACOES: 605,
  CRITERIOS_PRIORIZACAO: 606,
  PORTFOLIO_PROJETOS: 607,
  FLUXO_APROVACAO_GENERICO: 608,
  GESTAO_MUDANCAS_PROJETO: 609,
  MATRIZ_RESPONSABILIDADES_ATIVIDADE: 610,
  MATRIZ_RESPONSABILIDADES_RESPONSABILIDADE: 611,
  GESTAO_MUDANCAS_INDICADOR: 612,
  GESTAO_MUDANCAS_PARAMETRO: 613,
  GESTAO_MUDANCAS_OBJETIVOESTRATEGICO: 614,
  CARD_METAS: 312,
  LOG_INTEGRACAO_API_COLABORADOR: 61,
  LOG_INTEGRACAO_API_HISTORICO_CARGO: 62,
  LOG_INTEGRACAO_API_CARGO: 63,
  LOG_INTEGRACAO_API_ORGANIZACAO: 64,
  LOG_INTEGRACAO_API_VALOR_REALIZADO: 65,
  PLANOCONTAS_PROJETO: 615,
  RECURSO: 622,
  LISTAALOCACAORECURSOS: 625,
  PROJETO_STAKEHOLDERS_TAREFAS: 705,
  REGRA_PRIORIZACAO: 626,
  APROVACAO_PROJETO_STAGE_GATE: 631,
  VISUALIZACAO_STATUS_REPORTS: 632,
  APROVACAO_PROJETO_STAGE_GATE_DASHBOARD: 633,
  ACOMPANHAR_LICOES_APRENDIDAS: 628,
  LICOES_APRENDIDAS_PROJETO: 634,
  PROJETOS_AGEIS: 635,

  // RV
  MODELO_VISUALIZACAO_COMISSOES: 337,
  DRILLDOWN_COMISSOES: 205,
  WEBHOOK: 206,
  WEBHOOK_LOG: 207,
  WEBHOOK_LOG_REQUISICAO: 208,
  DETALHAMENTO_PROVISOES: 209,
  FUNCOES: 216,
  // GED
  DOCUMENTO: 701,
  DOCUMENTOVERSIONAMENTOMANUAL: 702,
  GESTAO_MUDANCAS_DOCUMENTO: 703,
  PUBLICOINTERESSADO: 704,
  DOCUMENTOS_PUBLICADOS: 706,
  COPIAS_CONTROLADAS_DISTRIBUIDAS: 707,

  // COMISSOES
  VENDA: 801,
  REGRA_COMISSIONAMENTO: 802,
};

/* Mesmo ID do backend (Portal.Web.Info.TagMenu) */
export const COLUNAS = {
  PROJETO_AGIL: 2029,
  AVALIACAO: 12001,
  RISCO_REVISOES_PONTO_CONTROLE: 12002,
  PONTO_CONTROLE: 12003,
  REVISOES_PENDENTES: 12004,
  VALIDACOES_REVISOES_PONTO_CONTROLE: 12005,
  REVISOES_PONTO_CONTROLE: 12006,
  AVALIACAO_PENDENTE: 12007,
  RISCO_PONTO_CONTROLE: 12022,
  INDICADOR_RISCO: 12024,
  PLANOS_CONTIGENCIA: 12025,
  EVENTO_RISCO: 12026,
  MODELO_CHECKLIST: 12027,
  AUDITORIA_RISCO: 12028,
  CONTROL_SELF_ASSESSMENT: 12029,
  RESULTADO_AUDITORIA: 12030,
  PONTO_AUDITORIA: 12031,
  CRITERIOS_AVALIACAO: 12032,
  TESTE_CONTROLE: 12033,
  PERDAS_OPERACIONAIS: 12034,
  DICIONARIO_RISCOS: 12035,
  CRITERIOS_EFETIVIDADE: 12036,
  NIVEL_PROFICIENCIA: 13001,
  NIVEL_EDUCACIONAL: 13002,
  LOCALIDADE: 13003,
  ORIENTACAO_SEXUAL: 13004,
  RACA: 13005,
  MODELO_AVALIACAO: 13006,
  GRUPO_AVALIADOS: 13007,
  ELEMENTO_MODELO_AVALIACAO: 13008,
  LINGUA: 13009,
  MODELO_ESCALA: 13010,
  CICLO_AVALIACAO: 13011,
  CALIBRACAO: 13012,
  RESULTADOS_REUNIAO_GENTE: 13013,
  RESULTADOS_MEU_DESEMPENHO: 13014,
  RESULTADOS_CICLO_AVALIACAO: 13015,
  RESULTADOS_DESEMPENHO_TIME: 13016,
  CRITICIDADE_CARGO: 13017,
  FAIXA_TEMPO_CARGO: 13018,
  FAIXA_TEMPO_EMPRESA: 13019,
  FAIXA_TEMPO_LIDER_CARGO: 13020,
  FAIXA_IDADE: 13021,
  CICLO_META_INDIVIDUAL: 13022,
  BIBLIOTECA_ACOES_PDI: 13023,
  MAPA_SUCESSAO: 13024,
  PORTFOLIO_PROJETOS: 15001,
  SUBPROJETOS_RESUMO_PROJETO: 15002,
  RELACIONAMENTOS_RESUMO_PROJETO: 15003,
  PROJETO_STATUS_REPORT: 15004,
  VALORES_INDICADORES_DE_PROJETO: 15005,
  PROJETOS_FLUXO_APROVACAO: 15006,
  APROVAR_ACOES: 15008,
  FLUXO_APROVACAO_GENERICO: 15009,
  GESTAO_MUDANCAS_PROJETO: 15010,
  GESTAO_MUDANCAS_INDICADOR: 15011,
  GESTAO_MUDANCAS_PARAMETRO: 15012,
  GESTAO_MUDANCAS_OBJETIVOESTRATEGICO: 15013,
  GESTAO_MUDANCAS_RISCO: 15014,
  GESTAO_MUDANCAS_DOCUMENTO: 1501,
  GESTAO_MUDANCAS_CADASTRO_VERSAO: 1502,
  GESTAO_MUDANCAS_RISCO_AVALIACAO: 15017,
  CARD_METAS: 11004,
  LOG_INTEGRACAO_API_COLABORADOR: 5010,
  LOG_INTEGRACAO_API_HISTORICO_CARGO: 5011,
  LOG_INTEGRACAO_API_CARGO: 5012,
  LOG_INTEGRACAO_API_ORGANIZACAO: 5013,
  LOG_INTEGRACAO_API_VALOR_REALIZADO: 5014,
  CESTA_INDICADOR_BONUS: 10008,
  CESTA_INDICADOR_COMISSAO: 10008,
  RELATORIOBSC: 3015,
  ACAO_TAREFA: 5011,
  CONTRATORESULTADOS: 11007,
  RELATORIO_STATUS_REPORT: 15014,
  PLANOCONTAS_PROJETO: 15015,
  PLANOCONTAS_PROJETO_VALOR: 15016,
  DOCUMENTO: 16001,
  DOCUMENTOVERSIONAMENTOMANUAL: 16002,
  PUBLICOINTERESSADO: 16003,
  DOCUMENTOS_PUBLICADOS: 16004,
  COPIAS_CONTROLADAS_DISTRIBUIDAS: 16005,
  CHAVERESULTADO_INICIATIVA: 17001,
  CESTA_INDICADOR_ITENS: 11013,
  RECURSO: 15020,
  LISTAALOCACAORECURSOS: 15021,
  PROJETO_STAKEHOLDERS_TAREFAS: 17002,
  LOG_AUDITORIA: 5015,
  FILTROFAVORITO: 5016,
  ESTATISTICAS: 3012,
  PLANOCONTAS: 1015,
  CHECKINS: 14003,
  VISUALIZACAO_STATUS_REPORTS: 13025,
  PESQUISA_CLIMA: 13026,
  GRUPO_DOSSIE: 13027,
  SOLICITACAO_DOSSIE: 13028,
  COLABORADOR_LOOKUP: 1016,
  RISCOS_ITENS_IMPACTADOS: 12038,
  VENDA: 17003,
  REGRA_COMISSIONAMENTO: 17004,
  REUNIAO_GENTE: 18004,
  REUNIAO_GENTE_LOOKUP: 18005,
  MINHAS_OCORRENCIAS: 19001,
};

/* Mesmo ID do backend (Domain.Apresentacao.TipoObjeto) */
export const APRESENTACAO = {
  RISCO: 'Risco',
  PONTOCONTROLE: 'PontoControle',
  REVISOESPONTOCONTROLE: 'RevisoesPontoControle',
  MATRIZRISCO: 'MatrizRisco',
  CALENDARIO: 'Calendario',
  RESULTADOITEM: 'ResultadoItem',
};

export const WIDGET_CUSTOM = {
  INDICADOR: 1,
  PARAMETRO: 2,
  OBJETIVO: 3,
  GRAFICOCOMPARATIVO: 4,
  GRAFICODESVIO: 5,
  GRAFICO: 6,
  GRAFICOACOES: 7,
  PROJETO: 8,
  ACAO: 9,
  GRAFICOINDICADORES: 10,
  GRAFICOPACOTECONTA: 11,
  PACOTECENTROCUSTO: 12,
  GRAFICOVELOCIMETRO: 13,
  RISCO: 14,
  GRAFICOESTATISTICAS: 17,
  GRAFICOGANHOSPORACAO: 18,
  GRAFICODESVIOSPORACAO: 19,
  TABELAVALORES: 20,
  GRAFICOPIZZAMULTINIVEL: 21,
  STATUSREPORT: 22,
  ADERENCIAAOMETODO: 23,
  GRAFICOCURVAS: 24,
  RELATORIOACOMPANHAMENTO: 25,
  REVISOESPONTOCONTROLE: 26,
  QUANTITATIVOREVISOESPONTOCONTROLE: 27,
  CALENDARIO: 28,
  QUANTITATIVORISCOS: 29,
  CARDMETAS: 30,
  POSTIT: 31,
  ISHIKAWA: 32,
  ANEXO: 100,
  CIRCULO: 101,
  RETANGULO: 102,
  IMAGEM: 103,
  TEXTO: 104,
  LINK: 105,
  CAMPOCOMENTARIO: 106,
  MATRIZRISCO: 107,
  OKR: 108,
  EVOLUCAOSCORERISCO: 109,
  TABELA_PROJETOS: 110,
  TABELA_ACOES: 111,
  SCORE: 112,
  W5PORQUES: 113,
  MATRIZGUT: 114,
  IMPACTO_FINANCEIRO_INERENTE: 115,
  IMPACTO_FINANCEIRO_RESIDUAL: 116,
  IMPACTO_FINANCEIRO_REDUCAO: 117,
  SHAREPOINT: 118,
  QUANTITATIVOPROJETOS: 119,
  PENDENCIASRESPONSABILIDADES: 120,
  INDICADORESFAVORITOS: 121,
  DASHBOARDSFAVORITOS: 122,
  ESTATISTICAS: 123,
  QUANTITATIVO_KRS: 124,
  DESEMPENHOOKRS: 125,
  OKRSPORFAROL: 126,
  ORCAMENTO_PROJETOS_VALOR: 127,
  ORCAMENTO_PROJETOS_GRAFICO: 128,
  RISCO_RANKING: 129,
  LINKDASHBOARD: 130,
  INDICADORES_RISCO: 131,
  DETALHAMENTO_PLANO_CONTAS: 132,
  DESEMPENHO_PROJETO: 133,
  TABELA_INICIATIVAS: 134,
  COMENTARIOS_ITEM: 135,
  QUANTITATIVO_AUDITORIA: 136,
  GRAFICO_GAUGE_SCORE: 137,
  PROCESSO: 138,
  QUANTITATIVOITENS: 139,
  MATRIZ_PROCESSOS: 140,
  QUANTITATIVO_PERDA_OPERACIONAL: 141,
  VALOR_PERDA_OPERACIONAL: 142,
  QUANTITATIVO_PONTO_AUDITORIA: 143,
};

export const REUNIAO = {
  PENDENTE: 1,
  CONFIRMADO: 2,
  RECUSADO: 3,
};

/* Mesmo ID do backend (Domain.FlyWeight.TipoEventoCalendario) */
export const EVENTOS_CALENDARIO = {
  INICIOACOES: { id: 1, icone: 'clock-start' },
  TERMINOACOES: { id: 2, icone: 'clock-end' },
  VALORESDESATUALIZADOS: { id: 3, icone: 'numeric' },
  REUNIOES: { id: 4, icone: 'calendar' },
  REVISOESPONTOCONTROLE: { id: 5, alphaLetter: 'P' },
  AVALIACOESRISCO: { id: 6, alphaLetter: 'R' },
};

export const TIPO_EXIBICAO_CALENDARIO = {
  DIA: 'day',
  SEMANA: 'week',
  MES: 'month',
  AGENDA: 'agenda',
};

export const STATUS_CONFIRMACAO_LEITURA_ARQUIVO = {
  NAO_ACESSADO: 1,
  VISUALIZADO: 2,
  BAIXADO: 3,
};

export const STATUS_LOG = {
  SUCESSO: 3,
  AVISO: 5,
  ERRO: 4,
};

export const COLABORADOR_CAMPOS = {
  EMAIL: 1,
  TELEFONE: 2,
  CELULAR: 3,
  LINKEDIN: 4,
  GENERO: 5,
  NOME_SOCIAL: 6,
  RACA: 7,
  ORIENTACAO_SEXUAL: 8,
  IDIOMAS: 9,
  CURSO_EXTRACURRICULAR: 10,
  FORMACAO_ACADEMICA: 11,
  DISPONIBILIDADE_MUDANCA: 12,
  INTERESSE_OUTRAS_AREAS: 13,
  AUTORIZACAO_DIVULGACAO_ANIVERSARIO: 14,
  CARGO: 15,
  EXPERIENCIASANTERIORES: 16,
  PAIS: 17,
};

export const MODULOS = {
  GESTAO_ESTRATEGICA: 1,
  MATRIZ_ORCAMENTARIA: 2,
  REMUNERACAO_VARIAVEL: 3,
  AVALIACAO_DESEMPENHO: 4,
  GESTAO_RISCO: 5,
  ESCRITORIO_PROJETOS: 7,
  INTELIGENCIA_ARTIFICIAL: 8,
  FRST: 10,
  HEFLO: 11,
};

export const MODULOS_COMPLETO = MODULOS_DESCRICAO;

export const TIPO_ELEMENTO_FORMULARIO = {
  GERAL: 'geral',
  SECAO: 'secao',
  SUBSECAO: 'subsecao',
  PERGUNTA: 'pergunta',
  TITULO: 'titulo',
  PARAGRAFO: 'paragrafo',
  IMAGEM: 'imagem',
  PERGUNTA_AVALIACAO_MULTIPLA: 'pergunta-interna',
};

export const PROCESSO_AVALIATIVO_TIPO_VISAO = {
  LIST: 1,
  EDIT: 2,
};

export const STATUS_PROCESSO_AVALIATIVO = {
  RASCUNHO: 0,
  PUBLICADO: 1,
  ATIVO: 2,
  CONCLUIDO: 3,
  CANCELADO: 99,
};

export const STATUS_CICLO_AVALIACAO = {
  CONCLUIDO: 3,
};

/* namespace Stratec.Domain.AvaliacaoDesempenho.TipoAvaliacaoEnum */
export const TIPO_AVALIACAO = {
  CONSOLIDADO: 0,
  AUTO_AVALIACAO: 1,
  LIDER: 2,
  LIDERADO: 3,
  PARES: 4,
  GESTOR_MATRICIAL: 5,
  FORMULARIO_COMPLEMENTAR: 6,
  FORMULARIO_ENTREGAS: 7,
};

export const STATUS_PROCESSO_AVALIATIVO_AVALIACAO = {
  PROGRAMADA: 1,
  A_INICIAR: 2,
  ATRASADA: 3,
  EM_ANDAMENTO: 4,
  CONCLUIDA: 5,
};

export const STATUS_PROCESSO_AVALIATIVO_FEEDBACK = {
  PROGRAMADO: 1,
  A_INICIAR: 2,
  ATRASADO: 3,
  CONCLUIDO: 4,
  RASCUNHO: 5,
};

export const STATUS_AUDITORIA = {
  RASCUNHO: 0,
  ATIVO: 1,
  CONCLUIDO: 2,
};

export const EIXO_LIFTBOX = {
  EIXO_VERTICAL: 'EixoVertical',
  EIXO_HORIZONTAL: 'EixoHorizontal',
};

export const LIFTBOX_VIEW = {
  CONFIGURACAO: 1,
  CALIBRACAO: 2,
};

export const LIFTBOX_SNAPSHOT = {
  PRE_CALIBRACAO: 1,
  POS_CALIBRACAO: 2,
};

export const FUNCAO_FORMULA_LIFTBOX = {
  SOMA: 1,
  MEDIA_ARITMETICA: 2,
  MEDIA_PONDERADA: 3,
  COMPONENTE_IGUAL: 4,
};

export const FATOR_FORMULA_LIFTBOX = {
  META: 1,
  RESULTADO_AVALIACAO: 2,
  SECAO_SUBSECAO: 3,
};
export const TIPO_ITENS = {
  INDICADOR: 1,
  PARAMETRO: 2,
  OBJETIVO_ESTRATEGICO: 3,
  PROJETO: 4,
  PROCESSO: 5,
  RISCO: 6,
  REUNIAO: 7,
  CENTRO_CUSTO: 8,
  PACOTE: 9,
  DESEMPENHO_INDIVIDUAL: 10,
  CALCULO_INTERMEDIARIO: 11,
  TEMPLATE_INDICADOR: 12,
  TEMPLATE_PARAMETRO: 13,
  TEMPLATE_OBJETIVO_ESTRATEGICO: 14,
  TEMPLATE_PROJETO: 15,
  ORCAMENTO: 16,
  INDICADOR_RISCO: 17,
  EVENTOS_RISCO: 18,
  AUDITORIA_RISCO: 19,
  CONTROL_SELF_ASSESSMENT: 20,
  AUDITORIA_CHECKLIST: 21,
  GESTAO_DOCUMENTOS: 22,
  PONTO_CONTROLE: 23,
  PERDA_OPERACIONAL: 24,
  AVALIACAO_RISCO: 25,
  CALIBRACAO: 26,
  PROJETOS_AGEIS: 27,
};

export const TIPO_CAMPO_CUSTOMIZADO = {
  TEXTO: 1,
  MULTILINHA: 2,
  INTEIRO: 3,
  DECIMAL: 4,
  VALOR_TABELADO: 5,
};

export const STATUS_PONTO_CONTROLE_REVISAO = {
  NAO_INICIADA: 1,
  EM_ANDAMENTO: 2,
  CONCLUIDO: 4,
  EM_VALIDACAO: 5,
  REPROVADO: 6,
};

export const STATUS_AVALIACAO_RISCO = {
  PENDENTE: 1,
  CONCLUIDO: 2,
  EM_ANDAMENTO: 3,
  EM_VALIDACAO: 4,
};

export const TIPO_COLABORADOR = {
  INTERNO: 1,
  EXTERNO: 2,
};

export const TIPO_GRAFICO_RISCO = {
  COLUNAS: 1,
  COLUNAS_EMPILHADAS: 2,
  PIZZA: 3,
};

export const LICENSE_KEYS = {
  FUSIONCHARTS:
    'xjB3fB-8qH2B7B2D5C4A4A4C3I3A2C11A5C7qhhD4F1H3hD7E6F4A-9A-8kD2I3B6uwfB2C1C1uomB1E6B1C3F3C2A21A14B14A8D8bddH4C2WA9hlcE3E1A2raC5JD4E2F-11C-9hH1B3C2B4A4D4F3E4E2D2H3C3D2A5v==',
};

export const CICLO_AVALIACAO_ETAPAS = {
  AVALIACAO: 1,
  AVALIACAO_PARES: 104,
  AVALIACAO_GESTOR_MATRICIAL: 105,
  FORMULARIO_ENTREGAS: 202,
  FEEDBACK: 2,
  PDI: 3,
  CALIBRACAO: 5,
};

export const TIPOS_ETAPAS_AVALIACAO = {
  AUTO_AVALIACAO: 101,
  AVALIACAO_LIDER: 102,
  AVALIACAO_LIDERADO: 103,
  AVALIACAO_PARES: 104,
  AVALIACAO_GESTOR_MATRICIAL: 105,
  FORMULARIO_COMPLEMENTAR: 201,
  FORMULARIO_ENTREGAS: 202,
};

export const STATUS_APROVACAO_AVALIACAO = {
  PENDENTE_INDICACAO: 0,
  PENDENTE_APROVACAO: 1,
  APROVADO: 2,
  PENDENTE_SOLICITACAO: 3,
  REPROVADO: 4,
};

export const REUNIAO_GENTE_LISTA = {
  PUBLICO: 0,
  LIDERES: 1,
  CONVIDADOS: 2,
};

export const TIPO_FAIXA_FAROL = {
  INDICADOR_RISCO: 12,
};

export const DASHBOARD_DETALHAMENTO_AVALIACAO_VIEW = {
  TIPO_AVALIACAO: 1,
  COLABORADOR_AREA_EMPRESA: 2,
};

export const TIPO_AVALIACAO_COR = {
  CONSOLIDADO: 'rgb(73, 80, 87, .2)',
  AUTO_AVALIACAO: 'rgb(255, 184, 0, .2)',
  LIDER: 'rgb(4, 77, 186, .2)',
  GESTOR_MATRICIAL: 'rgb(221, 205, 242, .2)',
  LIDERADO: 'rgb(131, 95, 3, .2)',
  PARES: 'rgb(9, 177, 188, .2)',
};

export const DASHBOARD_DETALHAMENTO_AVALIACAO_COLABORADOR_AREA_EMPRESA_BENCHMARK =
  {
    AVALIADO: 1,
    CARGO: 2,
    AREA: 3,
    EMPRESA: 4,
    BENCHMARK: 5,
  };

export const DASHBOARD_DETALHAMENTO_AVALIACAO_COLABORADOR_AREA_EMPRESA_BENCHMARK_COR =
  {
    AVALIADO: 'rgb(163,139,150, .2)',
    CARGO: 'rgb(215, 95, 135, .2)',
    AREA: 'rgb(215,218,63, .2)',
    EMPRESA: 'rgb(9,177,188, .2)',
    BENCHMARK: 'rgb(0,53,132, .2)',
  };

export const TEMA_REUNIAO_ONE_A_ONE = {
  FEEDBACK: 1,
  CONVERSA_LIVRE: 2,
  CONTRATACAO_DESEMPENHO: 3,
  TERMOMETRO_SENTIMENTO: 4,
};

export const STATUS_REUNIAO_ONE_A_ONE = {
  AGENDADA: 1,
  EM_ANDAMENTO: 2,
  CONCLUIDA: 3,
};

export const TRANSICAO_BANNER_LIFT = {
  MANUAL: 1,
  AUTOMATICA: 2,
};

export const STATUS_INTEGRACAO_RV_LIFTBOX = {
  AGUARDANDO: 1,
  EM_ANDAMENTO: 2,
};

export const TIPO_CONSOLIDACAO = {
  SOMA: 1,
  MEDIA: 2,
  FORMULA: 3,
  DIGITADO: 4,
  VALOR_EXTERNO: 5,
  VALOR_POWERBI: 6,
};

export const TIPO_CONSOLIDACAO_ACUMULADO = {
  FORMULA: 1,
  IGUAL_PERIODO: 2,
  MEDIA_PERIODO: 3,
  SOMA_PERIODO: 4,
  DIGITADO: 5,
  VALOR_EXTERNO: 6,
  VALOR_POWERBI: 7,
};

export const GANTT_VIEW = {
  GANTT: 'gantt',
  KANBAN: 'kanban',
};

export const ENTIDADE_ANEXOS = {
  PROJETO_STATUS_REPORT: 34,
  EVENTO_RISCO_AVALIACAO: 37,
  EVENTO_RISCO: 38,
  PLANO_CONTINGENCIA: 39,
  RISCO_AUDITORIA_AVALIACAO: 41,
  PLANO_TESTE_STEP: 44,
};

export const STATUS_PROJETO_TAP = {
  PENDENTE: 1,
  AUTORIZADO: 2,
};

export const TIPO_VALOR_PROJETO = {
  CUSTO_REAL: 1,
  VALOR_AGREGADO: 2,
  VALOR_PLANEJADO: 3,
  INDICE_DESEMPENHO_CUSTO: 4,
  INDICE_DESEMPENHO_PRAZO: 5,
  INDICE_DESEMPENHO_ESCOPO: 6,
};

export const TIPO_VALOR = {
  META: 1,
  REALIZADO: 2,
  METAACUMULADO: 4,
  REALIZADOACUMULADO: 5,
  ESTIMADO: 3,
  ESTIMADOACUMULADO: 6,
};

export const FAROL_ACAO = {
  ROXO: 1,
  AZUL: 2,
  VERDE: 3,
  AMARELO: 4,
  VERMELHO: 5,
  BRANCO: 6,
  PRETO: 7,
};

export const STATUS_ITEM = {
  EM_PLANEJAMENTO: 1,
  ATIVO: 2,
  CONCLUIDO: 3,
  SUSPENSO: 4,
  CANCELADO: 5,
  PENDENTE_CADASTRO: 6,
  REPROVADO: 7,
  REPROVADO_AGUARDANDO_SUBMISSAO: 8,
};

export const TIPO_FORMULA_PORTFOLIO_PROJETOS = {
  SOMA: 1,
  MEDIA: 2,
  MEDIA_PONDERADA: 3,
  PRODUTO: 4,
};

export const STATUS_ACAO = {
  EM_PLANEJAMENTO: 1,
  NAO_INICIADA: 2,
  CONCLUIDA: 3,
  CANCELADA: 4,
  EM_ANDAMENTO: 5,
  ARQUIVADA: 6,
  VALIDACAO: 7,
  PENDENTE_CADASTRO: 8,
  REPROVADA: 9,
};

export const TIPO_ENTIDADE_PRINCIPAL_SOLICITACAO_GESTAO_MUDANCAS = {
  PROJETO: 0,
  INDICADOR: 1,
  PARAMETRO: 2,
  OBJETIVOESTRATEGICO: 3,
  RISCO: 4,
  DOCUMENTO: 5,
  NEGOCIACAOMETAS: 6,
  STAGEGATE: 7,
};

export const TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_PROJETO = {
  PRAZO: 0,
  ESCOPO: 1,
  CUSTO: 2,
};
export const TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_RISCO = {
  INCLUSAO_RISCO: 0,
  AVALIACAO_RISCO: 1,
  ALTERACAO_STATUS_RISCO: 2,
};

export const TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_DOCUMENTO = {
  CADASTRO_VERSAO: 0,
  CADASTRO_DOCUMENTO: 1,
  REVALIDACAO_VERSAO: 2,
};

export const STATUS_SOLICITACAO_GESTAO_MUDANCAS = {
  PENDENTE: 0,
  APROVADA: 1,
  REPROVADA: 2,
  APROVADAPARCIALMENTE: 3,
  REPROVADO_AGUARDANDO_SUBMISSAO: 4,
};

export const STATUS_FLUXO_APROVACAO_GENERICO_VALIDACAO = {
  PENDENTE: 0,
  APROVADA: 1,
  REPROVADA: 2,
  APROVADAPARCIALMENTE: 3,
};

export const EXCEL_COLUMN_CHAR_LIMIT = 32767;

export const TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_INDICADOR = {
  REALIZADO: 0,
  META: 1,
  FORMULACALCULO: 2,
  METAACUMULADO: 4,
  REALIZADOACUMULADO: 5,
};

export const TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_PARAMETRO = {
  REALIZADO: 0,
  META: 1,
  FORMULACALCULO: 2,
  REALIZADOACUMULADO: 5,
};

export const TIPO_MUDANCA_SOLICITACAO_GESTAO_MUDANCAS_OBJETIVOESTRATEGICO = {
  REALIZADO: 0,
  META: 1,
  FORMULACALCULO: 2,
};

export const TIPO_INTERACAO_SOPHIE = {
  INSIGHTS_FEEDBACK_PROCESSO_AVALIATIVO: 'InsightsFeedbackProcessoAvaliativo',
  SUGERIR_ACOES_PDI: 'SugerirAcoesPDI',
  SUGERIR_RISCOS_ITENS_IMPACTADOS: 'SugerirRiscosItensImpactados',
  SUGERIR_CAUSA_RISCO: 'SugerirCausaRisco',
  SUGERIR_CONSEQUENCIA_RISCO: 'SugerirConsequenciaRisco',
  INSIGHTS_RISCO: 'InsightsRisco',
  SUGERIR_CONTROLES_RISCO: 'SugerirControlesRisco',
  SUGERIR_RISCO: 'SugerirRisco',
  INSIGHTS_PROJETO: 'InsightsProjeto',
  SUGERIR_ACOES_GANTT: 'SugerirAcoesGantt',
  SUGERIR_OBJETIVOS_OKR: 'SugerirObjetivosOKR',
  SUGERIR_KEY_RESULTS_OKR: 'SugerirKeyResultsOKR',
  SUGERIR_CAUSA_SOLUCAO_PROBLEMAS: 'SugerirCausaSolucaoProblemas',
  UPLOAD_ARQUIVOSURLS_SOPHIEPREMIUM: 'UploadArquivosUrlsSophiePremium',
  INSIGHTS_AUDITORIA: 'InsightsAuditoria',
  INSIGHTS_PESQUISA_CLIMA: 'InsightsPesquisaClima',
  RESUMO_COLABORADOR: 'ResumoColaboradorWidget',
  CHATBOT_SUPORTE: 'ChatbotSuporte',
  UPLOAD_ARQUIVOS_GED: 'UploadArquivosGed',
  INSIGHTS_GESTAO_DOCUMENTOS: 'InsightsGestaoDocumentos',
  RESUMO_TRANSCRICAO_TEAMS: 'ResumoTranscricaoTeams',
  DOSSIE_COLABORADOR: 'DossieColaborador',
};

/**
 * label legvel pra exibir no GA
 */
export const TIPO_INTERACAO_SOPHIE_LABEL = {
  [TIPO_INTERACAO_SOPHIE.SUGERIR_CAUSA_SOLUCAO_PROBLEMAS]:
    'Sugestão de Causas - Solução de Problemas',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_OBJETIVOS_OKR]: 'Sugestão de Objetivos - OKRs',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_KEY_RESULTS_OKR]:
    'Sugestão de Key Results - OKRs',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_ACOES_GANTT]:
    'Sugestão de Ações - Planos de Ação (Gantt)',
  [TIPO_INTERACAO_SOPHIE.INSIGHTS_PROJETO]: 'Insights para Projetos',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_RISCO]: 'Sugerir Riscos',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_CONTROLES_RISCO]: 'Sugerir Controles de Risco',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_CAUSA_RISCO]: 'Sugerir Causas de Risco',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_CONSEQUENCIA_RISCO]:
    'Sugerir Consequências de Risco',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_RISCOS_ITENS_IMPACTADOS]:
    'Sugerir Riscos - Itens Impactados',
  [TIPO_INTERACAO_SOPHIE.INSIGHTS_RISCO]: 'Insights para Riscos',
  [TIPO_INTERACAO_SOPHIE.SUGERIR_ACOES_PDI]: 'Sugestão de Ações PDI',
  [TIPO_INTERACAO_SOPHIE.INSIGHTS_FEEDBACK_PROCESSO_AVALIATIVO]:
    'Insights para Feedback do Processo Avaliativo',
  [TIPO_INTERACAO_SOPHIE.UPLOAD_ARQUIVOSURLS_SOPHIEPREMIUM]:
    'Upload de Arquivos/URLs (Sophie Premium)',
  [TIPO_INTERACAO_SOPHIE.INSIGHTS_AUDITORIA]: 'Insights para Auditorias',
  [TIPO_INTERACAO_SOPHIE.INSIGHTS_PESQUISA_CLIMA]:
    'Insights para Pesquisa de Clima',
};

export const TIPO_INTEGRACAO_CONNECTOR = {
  COLABORADOR: 0,
  HISTORICO_CARGO: 1,
  CARGO: 2,
  ORGANIZACAO: 3,
  VALOR_REALIZADO: 4,
};

export const EXCEPTION_CANCELLATION_TOKEN = 'cancelation token';

export const UNKNOWN_PATHNAME = 'pathname-to-reset-everything';

export const STATUS_CESTA_META_INDIVIDUAL = {
  RASCUNHO: 1,
  PENDENTE_APROVACAO: 2,
  APROVADA: 3,
  REPROVADA: 4,
  ATIVA: 5,
  CONCLUIDA: 6,
  EM_REVISAO: 7,
  PENDENTE_VALIDACAO: 8,
};

export const STATUS_DOCUMENTO = {
  VIGENTE: 1,
  RASCUNHO: 2,
  APROVADO: 3,
  VENCIDO: 4,
  PENDENTE_APROVACAO: 5,
  CONCLUIDO: 6,
  REPROVADO: 7,
  REPROVADO_AGUARDANDO_SUBMISSAO: 8,
};

export const STATUS_CICLO_META_INDIVIDUAL = {
  RASCUNHO: 1,
  REPROVADA: 2,
  ATIVA: 3,
  CANCELADA: 4,
  CONCLUIDA: 5,
};

export const STATUS_PESQUISA_CLIMA = {
  RASCUNHO: 1,
  AGENDADA: 2,
  EM_ANDAMENTO: 3,
  ENCERRADA: 4,
  CANCELADA: 5,
};

export const ADDONS = {
  METAS_INDIVIDUAIS: 1,
  COMISSOES: 2,
  CONNECTOR: 3,
  VALOR_POWERBI: 4,
  ELOGIOS: 5,
  AUDITORIA_RISCO: 6,
  FEEDBACK_CONTINUO: 7,
  CONTROL_SELF_ASSESSMENT: 8,
  GESTAO_DOCUMENTOS: 9,
  NEGOCIACAO_METAS: 10,
  TESTE_CONTROLE: 11,
  INTEGRACAO_POWERBI_AVALIACAORISCO: 12,
  DOSSIE_COLABORADOR: 13,
  PERDA_OPERACIONAL: 14,
  CONTRATOS_CONVENIOS: 15,
  PESQUISA_CLIMA: 16,
  PROJETOS_AGEIS: 17,
  GESTAO_OCORRENCIAS: 18,
};

export const TIPO_CESTA_INDICADOR = {
  BONUS: 1,
  COMISSAO: 2,
};

export const TIPO_GRAFICO_PROJETO = {
  COLUNAS: 1,
};

export const PERIODICIDADE = {
  DIARIA: 1,
  SEMANAL: 2,
  QUINZENAL: 3,
  MENSAL: 4,
  BIMESTRAL: 5,
  TRIMESTRAL: 6,
  QUADRIMESTRAL: 7,
  SEMESTRAL: 8,
  ANUAL: 9,
  CONFORME_CALENDARIO: 10,
  PERSONALIZADA: 11,
};

export const TIPO_MFA = {
  CODIGO_EMAIL: 1,
  AUTHENTICATOR: 2,
};

export const TIPO_OBJETIVO_DESEMPENHO_OKR = {
  AREA: 1,
  PROJETO: 2,
  COLABORADOR: 3,
  OBJETIVO_ESTRATEGICO: 4,
};

export const TIPO_VINCULO_OBJETIVO_OKR = {
  AREA: 1,
  COLABORADOR: 2,
  ITEM: 3,
};

export const ORIGEM_FAIXA_RESULTADO = {
  REMUNERACAO_VARIAVEL: 1,
  AUDITORIA: 2,
};

export const TIPO_LIBERACAO_RESULTADOS = {
  DATA_ATUAL: 1,
  DATA_PROGRAMADA: 2,
  APOS_FEEDBACK: 3,
};

export const AVALIACAO_TESTE_CONTROLE = {
  SATISFATORIO: 1,
  FRACO: 2,
  DEFICIENCIA_SEVERA: 3,
  NAO_TESTADO: 4,
};

export const TIPO_LOGIN = {
  SENHA: 1,
  SSO: 2,
};

export const VIEW_MODE = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const SECAO_DOSSIE_COLABORADOR = {
  PESSOAL: 1,
  FORMACOES_ACADEMICAS: 2,
  IDIOMAS: 3,
  EXPERIENCIAS_ANTERIORES: 4,
  CURSOS_EXTRACURRICULARES: 5,
  AUTORIZACAO_DIVULGACAO_ANIVERSARIO: 6,
  DISPONIBILIDADE_MUDANCA: 7,
  INTERESSE_OUTRAS_AREAS: 8,
  OUTROS: 9,
  REUNIAO_DE_GENTE: 11,
};

export const TIPO_GRUPO_DOSSIE = {
  POR_CRITERIOS: 2,
  PERSONALIZADO: 3,
  REUNIAO_GENTE: 4,
};

export const STATUS_GRUPO_DOSSIE = {
  NUNCA_GERADO: 1,
  ATUALIZADO: 2,
  DESATUALIZADO: 3,
  AGUARDANDO_PROCESSAMENTO: 4,
  PROCESSANDO: 5,
  CONCLUIDO_PARCIALMENTE: 6,
  ERRO: 7,
  ARQUIVO_EXPIRADO: 8,
};

export const STATUS_SOLICITACAO_DOSSIE = {
  AGUARDANDO: 1,
  PROCESSANDO: 2,
  CONCLUIDA: 3,
  CONCLUIDA_PARCIALMENTE: 4,
  ERRO: 5,
  CANCELADA: 6,
  EXPIRADA: 7,
};

export const FORMATO_ARQUIVO_DOSSIE = {
  PDF: 1,
};

export const AGRUPAMENTO_ARQUIVO_DOSSIE = {
  ARQUIVO_UNICO: 1,
  UM_ARQUIVO_POR_COLABORADOR: 2,
};

export const CAMPO_CARD_PESSOAL_DOSSIE = {
  GENERO: 'genero',
  NOME_SOCIAL: 'nomeSocial',
  RACA: 'raca',
  ORIENTACAO_SEXUAL: 'orientacaoSexual',
  LINKEDIN: 'linkedIn',
  PAIS: 'pais',
};

// Card de identificação (lateral esquerda do dossiê)
export const CARD_IDENTIFICACAO_DOSSIE = 0;

// Chaves dos campos fixos do card de identificação
export const CAMPO_CARD_IDENTIFICACAO_DOSSIE = {
  CARGO: 'cargo',
  AREA: 'area',
  LIDER: 'lider',
  GESTOR_MATRICIAL: 'gestorMatricial',
  TEMPO_EMPRESA: 'tempoEmpresa',
  TEMPO_NO_CARGO: 'tempoNoCargo',
  DATA_INICIO_CARGO_ATUAL: 'dataInicioCargoAtual',
};

export const ONBOARD_ORIGEM = {
  DASHBOARD_INDIVIDUAL: 1,
  MATRIZ_RESULTADOS: 2,
  VALORES: 3,
  AGENDA: 4,
  CADASTRO_REUNIOES: 5,
  CADASTRO_ACAO: 6,
  ESTATISTICAS: 7,
};

export const ACAO_INTERACAO_ONBOARD = {
  VER_DEPOIS: 1,
  FECHAR: 2,
  INICIAR_TOUR: 3,
};

export const ACAO_INTERACAO_FEEDBACK = {
  AVALIAR_DEPOIS: 1,
  FECHAR: 2,
};

export const TIPO_ITEM_FLUXO_APROVACAO = {
  PROJETO: 1,
  ITEM: 2,
  RISCO: 3,
  DOCUMENTO: 4,
};
export const TIPO_FLUXO_APROVACAO = {
  GESTAO_MUDANCAS: 1,
  STAGE_GATE: 3,
};

export const TIPO_FONTE_DE_DADOS = {
  API_REST: 1,
  AZURE_DATALAKE: 2,
  DATABRICKS: 3,
};

export const TIPO_IMPORTACAO = {
  AREA: 1,
  COLABORADOR: 2,
  INDICADOR: 3,
  OBJETIVO_ESTRATEGICO: 4,
  PARAMETRO: 5,
  PROJETO: 6,
  ACAO: 7,
  META: 8,
  REALIZADO: 9,
  ESTIMADO: 10,
  FORMULA_ITEM: 11,
  IMPACTO_INDIRETO: 12,
  TERMOS: 13,
  RELATORIO_ACOMPANHAMENTO: 14,
  DESDOBRAMENTO: 15,
  CENTRO_CUSTO: 16,
  PACOTE_CONTA: 17,
  META_PACOTE_CENTRO_CUSTO: 18,
  REALIZADO_PACOTE_CENTRO_CUSTO: 19,
  REPROCESSAMENTO_POR_DESDOBRAMENTO: 20,
  META_PARAMETRO: 21,
  REALIZADO_PARAMETROS: 22,
  FUNCOES: 23,
  SALARIOS: 24,
  CARGO: 25,
  CESTA_INDICADORES: 26,
  PONTOS_FAIXA_RESULTADO: 27,
  FUNCOES_COLABORADOR: 28,
  HISTORICO_OCUPACAO: 29,
  CALCULO_INTERMEDIARIO_DESEMPENHO: 30,
  DESEMPENHO_INDIVIDUAL: 31,
  CONDICIONANTES_FORMULA_BONUS: 32,
  ITEM_DESDOBRAMENTO: 33,
  RISCO: 34,
  VALORES_ESTIMADOS: 35,
  ACAO_PACOTE_CENTRO_CUSTO: 36,
  PROCESSO: 37,
  PONTO_CONTROLE: 38,
  ITENS_CESTA_INDICADORES: 39,
  RISCO_PONTO_CONTROLE: 40,
  META_GANHOS_ACAO: 41,
  REALIZADO_GANHOS_ACAO: 42,
  PERMISSAO_ORGANIZACAO: 43,
  PERMISSAO_CENTRO_CUSTO: 44,
  PERMISSAO_PACOTE_CONTA: 45,
  CLASSIFICACAO_MO: 48,
  FERIADO: 49,
  PONTO_CONTROLE_RECORRENCIA_PERIODICIDADE: 50,
  META_ACUMULADO: 51,
  REALIZADO_ACUMULADO: 52,
  ESTIMADO_ACUMULADO: 53,
  REALIZADOS_PENDENTES: 54,
  METAS_PENDENTES: 55,
  EXPORTAR_CARD_COMPLETO: 56,
  SCORE: 57,
  FORMULA_CESTA_INDICADORES: 58,
  EXPORTAR_CARD_COMPLETO_PERIODO: 59,
  FUNCOES_ORGANIZACAO: 60,
  FAIXA_MINIMO_MAXIMO: 61,
  PERMISSAO_ITEM: 62,
  COLABORADOR_CONDICIONANTE: 63,
  COLABORADOR_GATILHO: 64,
  RISCO_AVALIACAO: 65,
  TIPO_CARGO: 66,
  ELEMENTO_MODELO_AVALIACAO: 67,
  HISTORICO_ORGANIZACAO: 68,
  TIPO_CARD: 69,
  TIPO_CARD_ITEM: 70,
  CATEGORIA: 71,
  CESTA_INDICADORES_TIPO_CARD_ITEM: 72,
  INDICADOR_RISCO: 73,
  CESTA_INDICADOR_GATILHO: 74,
  CAUSAS_RISCOS: 75,
  CONSEQUENCIAS_RISCOS: 76,
  CHECKLIST_TAREFAS: 77,
  ORDENACAO_MATRIZ_RESULTADOS: 78,
  DISPONIBILIDADE_MUDANCAS_COLABORADOR: 79,
  INTERESSE_OUTRAS_AREAS_COLABORADOR: 80,
  CURSOS_EXTRACURRICULARES_COLABORADOR: 81,
  EXPERIENCIAS_ANTERIORES_COLABORADOR: 82,
  IDIOMAS_COLABORADOR: 83,
  FORMACOES_ACADEMICAS_COLABORADOR: 84,
  RELATORIO_ACOMPANHAMENTO_MO: 85,
  AVALIACOES_PROCESSO: 86,
  BONUS_COLABORADOR: 87,
  PROJETO_STATUS_REPORT: 88,
  PARAMETRO_EXTERNO: 89,
  TRADUCAO_NOME_ITEM: 90,
  TRADUCAO_NOME_ORGANIZACAO: 91,
  TRADUCAO_NOME_FUNCAO: 92,
  TRADUCAO_DESCRICAO_UNIDADE_MEDIDA: 93,
  TRADUCAO_DESCRICAO_DESDOBRAMENTO: 94,
  VALOR_EXTERNO_CONFIGURACAO: 95,
  VALOR_EXTERNO_CONSOLIDACAO_ITEM: 96,
  INDICADOR_RISCO_LIMITES: 97,
  GRUPO: 98,
  UNIDADE_MEDIDA: 100,
  FLUXO_APROVACAO_GENERICO: 101,
  FLUXO_APROVACAO_GENERICO_ETAPA: 102,
  ITEM_PONTOS_FAIXA_RESULTADO: 103,
  EVENTO_RISCO: 104,
  FLUXO_APROVACAO_ITEM: 105,
  VALOR_POWERBI_CONSOLIDACAO_ITEM: 106,
  TAGS: 111,
  PLANEJAMENTO_INICIAL: 112,
  PLANO_CONTAS: 113,
  VALORES_POR_PROJETO_CONTA: 114,
  ACAO_BIBLIOTECA_PDI: 115,
  FORMULARIO_COMPLEMENTAR_RESPOSTA: 116,
  REVISAO_CONTROLE: 117,
  OBJETIVO_OKR: 118,
  KEY_RESULT_OKR: 120,
  CHECKLIST_PERGUNTAS: 121,
  NEGOCIACAO_METAS_GRUPO: 124,
  NEGOCIACAO_METAS_FUNCOES_GRUPO: 125,
  NEGOCIACAO_METAS_ITENS_GRUPO: 126,
  FUNCOES_RELACIONADAS_ORGANIZACAO: 128,
  NEGOCIACAO_METAS_FUNCOES_NIVEL: 129,
  CICLO_NEGOCIACAO_METAS: 130,
  NIVEL_NEGOCIACAO_METAS: 131,
  CATALOGO_NEGOCIACAO_METAS: 132,
  CATALOGO_NEGOCIACAO_METAS_ORGANIZACAO: 133,
  TABELA_VALOR: 134,
  TABELA_VALOR_ITEM: 135,
  CATALOGO_NEGOCIACAO_METAS_ITEM: 136,
  PERMISSAO_OBJETIVO: 137,
  ALOCACAO_RECURSOS: 138,
  REALIZADO_INDICADOR_RISCO: 139,
  DOCUMENTO: 140,
  CHECKIN_KEY: 141,
  REALIZADOS_PENDENTES_INDICADOR_RISCO: 143,
  RESPOSTAS_AVALIACAO_DESEMPENHO: 144,
  FORMULA_INDICADOR_RISCO: 145,
  MOVIMENTACAOFINANCEIRA: 146,
  FILTROSPBI: 148,
  ADERENCIA_AO_METODO: 149,
  ITEM_FAIXA_FAROL: 152,
  FAIXA_FAROL: 153,
  LISTA_ANEXOS: 154,
  VALORES_TODOS_TIPOS: 155,
  REUNIOES: 157,
  COMENTARIOS: 158,
  INICIATIVAS_KEY_RESULT: 159,
  TAREFAS_INICIATIVAS_KEY_RESULT: 160,
  HISTORICO_ACESSO: 161,
  LOG_HISTORICOS: 162,
  PROJETOS_AGEIS: 163,
  PROJETOS_AGEIS_ATIVIDADE: 164,
  VENDA: 165,
};

export const TIPO_PRIORIZACAO_PORTFOLIO = {
  MODELO_PONTUACAO: 1,
  MODELO_AHP: 2,
};

export const TYPES_FILTER_OKR = {
  TODOS: 0,
  AREA: 1,
  ITEM: 2,
  COLABORADOR: 3,
};

export const TIPO_VISUALIZACAO_WIDGET_ESTATISTICA = {
  AREA: 1,
  COLABORADOR: 2,
  TAGS: 3,
};

export const TIPO_FUNCIONALIDADE_WIDGET_ESTATISTICA = {
  INDICADOR: 1,
  PARAMETRO: 2,
  OBJETIVO_ESTRATEGICO: 3,
  PROJETO: 4,
  ACAO: 5,
  RELATORIO_ACOMPANHAMENTO: 6,
  DOCUMENTO: 7,
  AUDITORIA: 8,
  TESTE_CONTROLE: 9,
  DASHBOARD: 10,
  OBJETIVO_OKR: 11,
  KEY_RESULT: 12,
  AREA: 13,
  REUNIAO: 14,
  INICIATIVA: 15,
  FUNCAO: 16,
};

export const TERMO_ABERTURA_CAMPOS_DEFAULT = {
  OBJETIVO: 1,
  PREMISSAS: 2,
  RESTRICOES: 3,
  MARCOS: 4,
  RETORNOPREVISTO: 5,
  INVESTIMENTOPREVISTO: 6,
};

export const STATUS_ETAPA_STAGEGATE = {
  NAO_INICIADO: 0,
  PENDENTE: 1,
  APROVADO: 2,
};

export const CONFORMIDADE = {
  CONFORME: 1,
  NAO_CONFORME: 2,
};

export const TIPO_FILTRO_DATA = {
  PERIODO: 1,
  MES_ANTERIOR: 2,
  MES_ATUAL: 3,
  ANO_ATUAL: 4,
  ULTIMOS_DOZE_MESES: 5,
  ULTIMOS_VINTE_QUATRO_MESES: 6,
  DESDE_QUANDO_HA_VALORES: 7,
  ULTIMOS_SEIS_PERIODOS: 8,
  PERIODO_ANTERIOR: 9,
  YEAR_TO_DATE: 10,
};

export const TIPO_EXPORTACAO_RELATORIO_GESTAO_RISCO = {
  RESULTADO_DETALHADO_AUDITORIA: 0,
  MATRIZ_ITENS_IMPACTADOS: 1,
  MATRIZ_INTERDEPENDENCIA_ITENS_IMPACTADOS: 2,
  HISTORICO_REVISAO_DE_CONTROLE: 3,
  HISTORICO_VALIDACAO_REVISAO_DE_CONTROLE: 4,
  PERDA_OPERACIONAL: 5,
  TESTE_CONTROLE: 6,
  COPIAS_CONTROLADAS_NAO_CONTROLADAS: 7,
};

export const JUSTIFICATIVA_MODELO_ESCALA = {
  OPCIONAL: 1,
  OBRIGATORIA: 2,
  OBRIGATORIA_CONFORME_NOTA: 3,
};

export const MODELO_ITEM = {
  INDIVIDUAL: 1,
  TEMPLATE: 2,
  ITEMTEMPLATE: 3,
  STAGEGATE: 4,
};

export const TIPO_ALERTA = {
  SOLICITACAO_DIGITACAO_VALORES_REALIZADOS: 1,
  SOLICITACAO_PREENCHIMENTO_SOLUCAO_PROBLEMAS: 2,
  VALORES_DESATUALIZADOS_RESPONSAVEL: 3,
  VALORES_DESATUALIZADOS_SUPERIOR_RESPONSAVEL: 4,
  APROVAR_VALORES_REALIZADOS: 5,
  ENCERRAMENTO_PRAZO_DIGITACAO_VALORES_REALIZADOS: 6,
  AVISO_COLABORADOR_SELECIONADO_COMO_DIGITADOR: 7,
  REPROVACAO_VALOR_REALIZADO: 8,
  ACAO_CADASTRADA_RESPONSAVEL: 9,
  INICIO_ACAO: 10,
  VENCIMENTO_ACAO: 11,
  ACAO_ATRASADA_RESPONSAVEL_ACAO: 12,
  ACAO_ATRASADA_RESPONSAVEL_PROJETO: 13,
  ESTOURADO_INVESTIMENTO_ACAO_RESPONSAVEL_ACAO: 14,
  ESTOURADO_INVESTIMENTO_ACAO_RESPONSAVEL_PROJETO: 15,
  CONCLUSAO_PLANO_ACAO: 16,
  ESTOURADO_INVESTIMENTO_PROJETO: 17,
  PROXIMIDADE_VENCIMENTO_ACAO: 18,
  META_NAO_ALCANCADA_MO: 19,
  RISCO_PONTO_CONTROLE_REVISAO_ATRASADO: 20,
  RISCO_ATRASADO: 21,
  VALIDAR_ACAO: 22,
  ACAO_NAO_VALIDADA: 23,
  RISCO_PENDENCIAS_USUARIO: 24,
  REVISAO_PONTO_CONTROLE_NAO_VALIDADA_RESPONSAVEL: 25,
  REVISAO_PONTO_CONTROLE_NAO_VALIDADA_RESPONSAVEL_PONTO_CONTROLE: 26,
  CONFORMIDADE_ALTERADA_REVISAO: 27,
  ALTERACAO_CARD_METAS: 28,
  ENVIO_CARD_METAS: 29,
  GESTAO_COLABORADORES: 30,
  REVISAO_PONTO_CONTROLE_APROVADA_REPROVADA: 31,
  CONTRATO_RESULTADOS_PENDENTE: 32,
  CHECK_IN_PENDENTE: 33,
  PROJETO_STATUS_REPORT_PENDENTE: 34,
  AUTORIZACAO_TAP: 35,
  PUBLICACAO_PROCESSO_AVALIATIVO: 36,
  LIFT_INICIO_PREENCHIMENTO_AVALIACAO: 37,
  FINAL_DO_PRAZO_AVALIACAO: 38,
  AVISO_VALIDACAO_PROJETO_FLUXO_APROVACAO: 40,
  VALIDACAO_ACAO_APROVACAO: 41,
  AVISO_VALIDACAO_ACAO_APROVACAO: 42,
  NOVA_VALIDACAO_SOLICITACAO_GESTAO_MUDANCAS: 43,
  AVISO_VALIDACAO_SOLICITACAO_GESTAO_MUDANCAS: 44,
  AVISO_VENCIMENTO_CONTROLE_RESPONSAVEL_VALIDACAO: 45,
  AVISO_VENCENDO_REVISAO_CONTROLE: 46,
  AVISO_TAREFA_CADASTRADA_ACAO: 47,
  AVISO_TAREFA_ATRASADA_ACAO: 48,
  AVISO_REPROVADO_INDICACAO_PAR: 49,
  VENCIMENTO_ALTERACAO_SENHA: 50,
  ELOGIO_CURTIDO: 51,
  COMENTARIO_ELOGIO_CURTIDO: 52,
  AUDITORIA_CONCLUSAO_AVISAR_RESPONSAVEL: 53,
  INDICADOR_RISCO_VIOLACAO_LIMITES: 54,
  RISCO_ALTERACAO_NIVEL_CRITICIDADE_RISCO: 55,
  PROXIMIDADE_VENCIMENTO_INICIATIVA_OKR: 56,
  AVISO_INICIATIVA_ATRASADA_OKR: 57,
  CONCLUSAO_PLANO_ACAO_ITEM: 58,
  INICIO_ETAPAS_CICLO_METAS_INDIVIDUAIS: 59,
  CESTA_DE_METAS_REPROVADA: 60,
  CESTA_DE_METAS_PENDENTE_APROVACAO: 61,
  TERMINO_ETAPAS_CICLO_METAS_INDIVIDUAIS: 62,
  CONTROL_SELF_ASSESSMENT_REVISAO_FINALIZADA: 63,
  CONTROL_SELF_ASSESSMENT_SOLICITACAO_APROVACAO: 64,
  ACAO_ATRASADA_EQUIPE_ACAO: 65,
  ACAO_CADASTRADA_EQUIPE: 66,
  EXCLUSAO_ITEM: 67,
  ADICIONAR_METAS: 68,
  APROVAR_METAS: 69,
  REVISAR_METAS: 70,
  CICLO_FINALIZADO: 71,
  PROXIMIDADE_ENCERRAMENTO_CICLO: 72,
  DOCUMENTO_DISPONIVEL_ASSINATURA: 73,
  DOCUMENTO_VENCIDO: 74,
  LIMITE_ARMAZENAMENTO_DOCUMENTOS_ATINGIDO: 75,
  CONCLUSAO_TESTE_CONTROLE: 76,
  CSA_EXECUCAO_DISPONIVEL: 77,
  FAROL_INDICADOR_RISCO: 78,
  AVALIACOES_PENDENTES_PRAZO_SE_APROXIMA: 79,
  ACAO_ATRASADA_ITENS_AREA_COLABORADOR: 80,
  ETAPA_FLUXO_APROVACAO_VENCIDA: 81,
  TERMO_ENCERRAMENTO_PROJETO: 82,
  CONTRATOS_RESPONSAVEL: 83,
  PARCELAS_VENCIDAS_CONTRATO: 84,
  CONTRATOS_VENCIDOS: 85,
  CONTRATOS_A_VENCER: 86,
  COMENTARIO_MENCAO: 87,
  RESUMO_COLABORADOR_ACTIO_IA: 88,
  VALIDACAO_ITEM_RASCUNHO: 89,
  STATUS_ITEM_RASCUNHO: 90,
  COMENTARIO_CURTIDO: 91,
  PERDA_OPERACIONAL_DISPONIVEL_ANALISE: 92,
  PERDA_OPERACIONAL_DISPONIVEL_REVISAO: 93,
  PERDA_OPERACIONAL_CONCLUIDA_NOTIFICAR_RESPONSAVEL_AREA: 94,
  COMENTARIO_RESPOSTA: 95,
  APROVACAO_ETAPA_STAGE_GATE: 96,
  ATUALIZACAO_ETAPA_STAGE_GATE: 97,
  PROXIMIDADE_VENCIMENTO_DOCUMENTO: 98,
  PROXIMIDADE_VENCIMENTO_ACAO_PDI: 99,
  SENTIMENTO_REGISTRADO_COLABORADOR: 102,
};

export const RECORRENCIA = {
  SEM_RECORRENCIA: 1,
  TODO_DIA_DA_SEMANA: 2,
  DIARIAMENTE: 3,
  SEMANALMENTE: 4,
  MENSALMENTE: 5,
  ANUALMENTE: 6,
  PERSONALIZADA: 7,
};

export const PERIODICIDADE_RECORRENCIA = {
  DIA: 1,
  SEMANA: 2,
  MES: 3,
  ANO: 4,
};

export const DIA_DA_SEMANA = {
  DOMINGO: 0,
  SEGUNDA: 1,
  TERCA: 2,
  QUARTA: 3,
  QUINTA: 4,
  SEXTA: 5,
  SABADO: 6,
};

export const TIPO_IDENTIFICACAO_FORMULARIO_GLOBAL = {
  CONFIDENCIAL: 1,
  ANONIMA: 2,
  IDENTIFICADA: 3,
};

export const FORMATO_EXIBICAO_FORMULARIO_GLOBAL = {
  PAGINA_UNICA: 1,
  PERGUNTA_POR_VEZ: 2,
};

export const MAX_EXPORT_LIMIT = 1000;

export const TIPO_AVALIACAO_RISCO = {
  INERENTE: 1,
  RESIDUAL: 2,
};

export const TIPO_DASHBOARD_INDIVIDUAL = {
  PADRAO: 1,
  CUSTOMIZADO: 2,
};

export const TIPO_TRANSFERENCIA = {
  INDICADOR: 1,
  PARAMETRO: 2,
  OBJETIVO_ESTRATEGICO: 3,
  PROJETO: 4,
  ACAO: 5,
  REUNIAO: 7,
  PONTO_CONTROLE: 8,
  RISCO: 9,
  AVALIACAO_RISCO: 10,
  PROCESSO: 11,
  DASHBOARD: 12,
  APRESENTACAO: 13,
  FLUXO_APROVACAO_DOCUMENTOS: 14,
  ITENS_IMPACTADOS: 15,
};

export const TIPO_EXCLUSAO_LOTE = {
  ITEM: 1,
  FUNCAO: 2,
  CESTA_INDICADOR: 3,
  RELATORIO_ACOMPANHAMENTO: 4,
  REUNIAO: 5,
  REVISAO_CONTROLE: 6,
  AVALIACAO_RISCO: 7,
  RISCO: 8,
  RISCO_CAUSA: 9,
  RISCO_CONSEQUENCIA: 10,
  CONTROLE: 11,
  ITENS_IMPACTADOS: 12,
  ITEM_CESTA_INDICADOR: 13,
  HISTORICO_OCUPACAO: 14,
  VALOR_MINIMO_MAXIMO: 15,
  CENTRO_CUSTO: 16,
  PACOTE: 17,
  STATUS_REPORT: 18,
  DOCUMENTO: 19,
  CARGO: 20,
};

export const TIPO_ACOMPANHAMENTO_TOLERANCIA_RISCO = {
  UNICA: 1,
  INDIVIDUAL: 2,
};

export const AGING = {
  VENCIDO: 1,
  ZERO_ATE_TRINTA: 2,
  TRINTA_E_UM_ATE_SESSENTA: 3,
  SESSENTA_E_UM_ATE_NOVENTA: 4,
  NOVENTA_E_UM_ATE_CENTO_E_OITENTA: 5,
  CENTO_E_OITENTA_E_UM_OU_MAIS: 6,
};

export const TIPO_COPIA_DOCUMENTO = {
  NAO_SE_APLICA: 0,
  COPIA_CONTROLADA: 1,
  COPIA_NAO_CONTROLADA: 2,
};

export const STATUS_GERAL_DOCUMENTO = {
  RASCUNHO: 0,
  EM_ELABORACAO: 1,
  ATIVO: 2,
  CANCELADO: 3,
  REPROVADO: 4,
  REPROVADO_AGUARDANDO_NOVA_SUBMISSAO: 5,
};

export const TAMANHO_MAX_ANEXO = {
  PADRAO: 15,
  ESTENDIDO: 100,
};

export const RELACAO_CONVIDADO_ONE_A_ONE = {
  LIDER: 1,
  LIDERADO: 2,
  PAR: 3,
  OUTRO: 4,
};

export const STATUS_ACOMPANHAMENTO = {
  REALIZADO: 1,
  NAO_NECESSARIO: 2,
  CONVERSA_AGENDADA: 3,
};
